import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
    },
    {
      path: "/empresa",
      name: "empresa",
      component: () =>
        import(/* webpackChunkName: "empresa" */ "./views/About.vue"),
    },
    {
      path: "/privacidade",
      name: "privacidade",
      component: () =>
        import(/* webpackChunkName: "empresa" */ "./views/Privacidade.vue"),
    },
    {
      path: "/produtos",
      name: "produtos",
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/Products.vue"),
    },
    {
      path: "/produtos/:id/:page?",
      props: true,
      name: "allproducts",
      component: () =>
        import(/* webpackChunkName: "allproducts" */ "./views/Products.vue"),
    },
    {
      path: "/promocoes/:id?/:page?",
      props: true,
      name: "promocoes",
      component: () =>
        import(/* webpackChunkName: "promocoes" */ "./views/Promocoes.vue"),
    },
    {
      path: "/dt_portfolio/:id",
      name: "produto",
      props: true,
      component: () =>
        import(/* webpackChunkName: "produto" */ "./views/Product.vue"),
    },
    {
      path: "/blog",
      name: "Blog",
      component: () =>
        import(/* webpackChunkName: "blog" */ "./views/Blog.vue"),
    },
    {
      path: "/blog/post/:id",
      name: "Post",
      props: true,
      component: () =>
        import(/* webpackChunkName: "post" */ "./views/Post.vue"),
    },
    {
      path: "/ambientes",
      name: "ambientes",
      component: () =>
        import(/* webpackChunkName: "ambientes" */ "./views/Environments.vue"),
    },
    {
      path: "/ambientes/:id",
      name: "allenvironments",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "allenvironments" */ "./views/Environments.vue"
        ),
    },
    {
      path: "/quotelist",
      name: "quotelist",
      component: () =>
        import(/* webpackChunkName: "quotelist" */ "./views/Cart.vue"),
    },
    {
      path: "/contato",
      name: "contato",
      component: () =>
        import(/* webpackChunkName: "contato" */ "./views/Contact.vue"),
    },
    {
      path: "/acabamentos",
      name: "acabamentos",
      component: () =>
        import(/* webpackChunkName: "acabamentos" */ "./views/Finishes.vue"),
    },
    {
      path: "/acabamentos/:id",
      name: "acabamentositem",
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "acabamentositem" */ "./views/Finishes.vue"
        ),
    },
    {
      path: "/search/:search(.*)",
      name: "Search",
      props: true,
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue"),
    },
    {
      path: "/sucesso/",
      name: "Sucesso",
      props: true,
      component: () =>
        import(/* webpackChunkName: "sucesso" */ "./views/Sucesso.vue"),
    },
    {
      path: "/contatosucesso/",
      name: "Sucesso",
      props: true,
      component: () =>
        import(/* webpackChunkName: "sucesso" */ "./views/Sucesso.vue"),
    },
    {
      path: "/privacidade/",
      name: "privacidade",
      props: true,
      component: () =>
        import(/* webpackChunkName: "sucesso" */ "./views/Privacidade.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.afterEach((from, to) => {
  if ("id" in to.params && to.name !== "Post") {
    return;
  }

  if (from.name === "allproducts" || from.name === "promocoes") {
    return;
  }

  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
});

export default router;
